/*
 * @Description:环境配置
 * @Author: kai.zhou
 * @Date: 2020-03-24 17:36:33
 * @LastEditors: Mayer
 * @LastEditTime: 2024-04-16 11:29:18
 */

//环境dev开发，sit测试，prd线上环境
let env: string;
if (window.location.hostname.indexOf("carlcare.in") > -1) {
  env = "ind";
// } else if (window.location.hostname.indexOf("mis.carlcare.com") > -1) {
//   env = "prd";
} else if (window.location.hostname.indexOf("preservice.carlcare.com") > -1) {
  env = "pre";
} else if (window.location.hostname.indexOf("mi-") > -1) {
  env = "sit";
} else {
  env = "dev";
}
//接口域名
let useUrlEnv: any = {
  dev: "/",
  // dev: "//test-carlcare.shalltry.com",
  sit: "//test-carlcare.shalltry.com",
  prd: "//mis.carlcare.com",
  pre: "//pre.carlcare.com",
  ind: "//ind-mis-carl.shalltry.com"
};

let API_BASE_URL = useUrlEnv[env];
export { API_BASE_URL };
